export enum EmployeesGender {
    MALE = 'male',
    FEMALE = 'female',
  }